import ViewController from "core/views/view.controller";

export default class CustomerDetailsCtrl extends ViewController {
    static $inject = ['$scope', 'textModal'];

    constructor() {
        super(...arguments);

        // Bindings
        this.editable = true;
        this.customer = null;
        this.withContactDivider = true;
        this.withAddressDivider = true;
    }

    $onChanges(changes) {
        if (changes.editable && this.editable == null) {
            this.editable = true;
        }

        if (changes.withContactDivider && this.withContactDivider == null) {
            this.withContactDivider = true;
        }

        if (changes.withAddressDivider && this.withAddressDivider == null) {
            this.withAddressDivider = true;
        }
    }

    editNote() {
        this.textModal.show({
            title: "NOTE_LABEL",
            text: this.customer.note,

            onSave: (text) => {
                this.customer.note = text;
            }
        })
    }

}




// WEBPACK FOOTER //
// ./src/modules/main/components/customer-details/customer-details.controller.js